import type { ImageSource } from "@/libs/image"
import { Graph } from "../../framework"
import type { FaceDetection } from "../../modules/types"
import { create as createFrame2Pixels } from "../../modules/quality/frame2pixels"
import { create as createBlurOnline } from "../../modules/quality/blur-online"

export interface QualityMetrics {
  blurScore: number
  timestamp?: number
}

export const create = async () => {
  const graph = new Graph<[ImageSource, FaceDetection | null], [QualityMetrics]>()

  const pixelsExtractor = createFrame2Pixels(graph)
  const blurDetector = await createBlurOnline(graph)
  graph.in(0).connect(pixelsExtractor.in(0))
  pixelsExtractor.out(0).connect(blurDetector.in(0))

  const qualityNode = graph.node<[number], [QualityMetrics]>({
    process: async (ctx) => {
      const blurScore = ctx.in(0)

      ctx.out(0, {
        blurScore: blurScore ?? 0,
        timestamp: Date.now(),
      })
    },
  })

  blurDetector.out(0).connect(qualityNode.in(0))
  qualityNode.out(0).connect(graph.out(0))

  return graph
}
